<template>
  <div class="attendance-wrapper">
    <el-row class="section-row dashboard-header-row">
      <div class="dashboard-header">
        <span class="custom-date"><i class="el-icon-s-claim"></i>{{ formattedDate }}</span>
      </div>
    </el-row>
    <el-row class="section-row" :gutter="16">
      <el-col :span="24">
          <AttendanceStatistics/>
      </el-col>
    </el-row>
    <el-row class="section-row" :gutter="16">
      <el-col :xs="24" :sm="24" :md="8" :lg="6">
        <StatusChart/>
      </el-col>
      <el-col :xs="24" :sm="24" :md="16" :lg="18">
          <AttendanceStatusChart/>
      </el-col>
    </el-row>
    <!-- Thống kê Album Ảnh -->
    <el-row class="section-row" :gutter="16" v-if="checkPermission(['studentQuality_ablum'])">
      <el-col :span="24">
        <AlbumStatisticsCard/>
      </el-col>
    </el-row>

    <el-row class="section-row tuition-chart-row" :gutter="16" v-if="checkPermission(['fees_2_finance_tuition_statistics'])">
      <el-col :xs="24" :sm="24" :md="12" :lg="12">
        <TuitionBillChart/>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12">
        <TuitionBillSummaryChart/>
      </el-col>
    </el-row>

    <el-row class="section-row" :gutter="16" v-if="checkPermission(['studentQuality_attendance'])
     || checkPermission(['attendance_v4'])" >
      <el-col :span="24">
        <ClassAttendanceTableCard/>
      </el-col>
    </el-row>

  </div>
</template>
<script>
import AttendanceStatistics from "@/views/dashboard/component/AttendanceStatistics.vue";
import StatusChart from "@/views/dashboard/component/StatusChart.vue";
import AttendanceStatusChart from "@/views/dashboard/component/AttendanceStatusChart.vue";
import TuitionBillChart from "@/views/dashboard/component/TuitionBillChart.vue";
import TuitionBillSummaryChart from "@/views/dashboard/component/TuitionBillSummaryChart.vue";
import ClassAttendanceTableCard from "@/views/dashboard/component/ClassAttendanceTableCard.vue";
import AlbumStatisticsCard from "@/views/dashboard/component/AlbumStatisticsCard.vue";
import checkPermission from "@/utils/permission";
import CommonOnekidsService from "@/services/CommonService/CommonOnekidsService";
import {mapState} from "vuex";

export default {
  components: {
    ClassAttendanceTableCard,
    AlbumStatisticsCard,
    TuitionBillSummaryChart,
    TuitionBillChart,
    AttendanceStatusChart,
    StatusChart,
    AttendanceStatistics,
  },
  data(){
    return {
      formattedDate: ''
    }
  },
  created() {
    this.formattedDate = this.getFormattedDate();
    sessionStorage.removeItem("breadcrumbList");
    this.$store.dispatch("layout/setBreadcrumbActions", []);
    let appTypeUser = this.$store.state.auth.user.appType;
    if (appTypeUser === "parent") {
      this.$alert(
          "Tính năng giành cho Phụ huynh đang được cập nhật",
          "Thông báo!",
          {
            confirmButtonText: "OK",
          }
      );
      localStorage.removeItem("user");
      this.$router.push("/login");
    }
    
    // Gọi API để cập nhật quyền khi component được load
    this.getApiMethod();
  },
  watch: {
    updateDashBoard: {
      handler() {
        this.getApiMethod();
      },
      deep: true
    }
  },
  computed: {
    ...mapState('layout', ['updateDashBoard']),
    getAppTypeUserLogin() {
      return this.$store.state.auth.user.appType;
    },
  },
  methods:{
    checkPermission,

    getApiMethod() {
      CommonOnekidsService.getApiAgain()
          .then((resp) => {
            let user = JSON.parse(localStorage.getItem("user"));
            user.apiSet = resp.data.data;
            localStorage.setItem("user", JSON.stringify(user));
            this.$store.dispatch("auth/setUserActions", user);
          })
          .catch((err) => {
            this.$message({
              message: err.response.data.message,
              type: "error",
            });
          });
    },

    getFormattedDate() {
      const today = new Date();

      // Mảng tên các thứ trong tuần
      const weekdays = [
        'Chủ Nhật',
        'Thứ Hai',
        'Thứ Ba',
        'Thứ Tư',
        'Thứ Năm',
        'Thứ Sáu',
        'Thứ Bảy'
      ];

      const dayOfWeek = weekdays[today.getDay()];
      const day = String(today.getDate()).padStart(2, '0');
      const month = String(today.getMonth() + 1).padStart(2, '0'); // tháng bắt đầu từ 0
      const year = today.getFullYear();

      return `${dayOfWeek}, ${day}/${month}/${year}`;
    },
    // changeBreadcrumbMethod(val) {
    //   let selectUrl = this.breadcrumbDataList.filter((x) => x.key === val);
    //   if (selectUrl.length > 0) {
    //     let dataList = selectUrl[0].value;
    //     sessionStorage.setItem("breadcrumbList", JSON.stringify(dataList));
    //     this.$store.dispatch("layout/setBreadcrumbActions", dataList);
    //   }
    // },
  }
}
</script>

<style scoped>
.attendance-wrapper {
  max-height: 100vh; /* tối đa 1 màn hình */
  overflow-y: auto; /* cho phép cuộn dọc */
  overflow-x: hidden; /* ẩn ngang */
  padding: 0 4px 16px;
  background: linear-gradient(135deg, #f8fbff 0%, #f3f6fc 45%, #eef3fb 100%);
}

/* Ẩn thanh cuộn dọc & ngang nhưng vẫn cuộn được */
.attendance-wrapper::-webkit-scrollbar {
  display: none; /* Chrome, Safari */
}

.attendance-wrapper {
  -ms-overflow-style: none; /* IE, Edge */
  scrollbar-width: none; /* Firefox */
}

.section-row {
  margin-bottom: 4px;
}

@media (min-width: 992px) {
  .tuition-chart-row {
    display: flex;
    align-items: stretch;
  }

  .tuition-chart-row::v-deep > .el-col {
    display: flex;
    flex-direction: column;
  }

  .tuition-chart-row::v-deep > .el-col > * {
    flex: 1;
    margin: 0;
  }
}

@media (max-width: 991px) {
  .tuition-chart-row::v-deep > .el-col + .el-col {
    margin-top: 0;
  }
}

.dashboard-header-row {
  margin-bottom: 6px;
}

.dashboard-header {
  width: 100%;
  display: flex;
  align-items: center;
}

.custom-date {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 999px;
  background: linear-gradient(180deg, #f4f7ff 0%, #edf2ff 100%);
  border: 1px solid #dbe4ff;
  font-size: 15px;
  font-weight: 700;
  color: #3b4a74;
}

@media (max-width: 1200px) {
  .attendance-wrapper {
    padding: 0 0 12px;
  }

  .section-row {
    margin-bottom: 2px;
  }
}
</style>
